import { translate } from '~l10n/client';
import { countBy } from 'underscore';

import { Student } from '~teacher/models/reports';

const getNumStudentsSelected = (students: Student[]) => {
  const emailsSelected = countBy(
    students,
    (student: Student) => student.isSelected
  );
  return emailsSelected.true || 0;
};

const getNumStudentEmailsAndParticipated = (students: Student[]) => {
  const numStudentEmailsAndParticipation = countBy(
    students,
    (student: Student) => !!student.email && student.hasParticipated
  );
  return numStudentEmailsAndParticipation.true || 0;
};

const getUIButtonText = (numSelectedStudents: number, students: Student[]) => {
  if (numSelectedStudents === 1) {
    return translate('Email 1 Student');
  } else if (numSelectedStudents === students.length) {
    return translate(`Email All {0} Students`).format(students.length);
  } else if (numSelectedStudents === 0) {
    return translate('Email Students');
  }

  return translate('Email {0} Students').format(numSelectedStudents);
};

export {
  getNumStudentEmailsAndParticipated,
  getUIButtonText,
  getNumStudentsSelected,
};
